import { EsqueletoDeCartao, EstadoDeErro } from "@base/ui";
import { mensagemDoErro } from "../../../shared/http/mensagem-de-erro";
import { useDetalheDaConta } from "../application/central.contexto";
import { PaginaDaConta } from "./pagina-da-conta";

/** Detalhe da conta buscado na API, com carregando e erro no padrão da Central. */
export function ContaAoVivo() {
  const consulta = useDetalheDaConta();
  if (consulta.isLoading) return <EsqueletoDeCartao rotulo="Carregando a conta" />;
  if (consulta.isError) {
    return (
      <EstadoDeErro mensagem={mensagemDoErro(consulta.error)} aoTentarNovamente={() => void consulta.refetch()} />
    );
  }
  return <PaginaDaConta detalhe={consulta.data ?? null} />;
}
